export const updateCellDataAction = [
  {
    name: 'updateCellData',
    label: 'Update Cell Data',
    args: [
      {
        name: 'collection',
        label: 'collection',
        type: 'dropdown',
        optionsType: 'collectionConstructorApi',
        options: [],
        value: '',
      },
      {
        name: 'collectionRequest',
        label: 'Select Request Type (Optional)',
        type: 'dropdown',
        optionsType: 'collectionRequestApi',
        options: [],
        value: '',
      },
      {
        name: 'successMessage',
        label: 'Success Message',
        type: 'text',
        value: '',
      },
      {
        name: 'errorMessage',
        label: 'Error Message',
        type: 'text',
        value: '',
      },
    ],
  },
];
